import z from "zod"
import { Errors } from "../../errors"

export const UpsertFrontAppIntegrationSchema = z.object({
  token: z.string().min(1, { message: Errors.FRONTAPP_TOKEN_REQUIRED }),
})
